var $ = require('jquery');

var ArticleSingle = function($target) {

	var self = this;
	self.$iframe = $('p:has(iframe)');

	function init() {
        self.$iframe.addClass('iframe-container');
	}

	init();
};

module.exports = ArticleSingle;